var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',{attrs:{"three-line":""}},[_c('v-divider'),_vm._l((_vm.items),function(user,i){return [_c('list-user-item',{key:i,attrs:{"item":user,"icon":"fas fa-user-circle"}}),_c('v-divider',{key:i + 'd'})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }